var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCornerScalloped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_corner_scalloped") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_corner_scalloped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_shape_rectangle_scallop_none",
    transform: "translate(0, -0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3257721,0 C30.0276086,0 29.7418723,0.119439191 29.5321031,0.331285184 L29.0926287,0.773931435 C28.8940219,0.973852331 28.7777521,1.24105208 28.7668459,1.52261357 C28.2687398,16.4086183 16.4002262,28.4063645 1.51737322,29.0687975 C1.23284447,29.0787558 0.962929367,29.1972599 0.763064182,29.3999708 L0.323589781,29.8437363 C0.115940704,30.0529832 0,30.335913 0,30.6306729 L0,60 L58.880548,60 C59.1774979,60 59.462335,59.8823114 59.6723103,59.6723821 C59.8822856,59.4624527 60,59.177678 60,58.8807931 L60,0 L30.3257721,0 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.880548,1.11996776 L58.880548,58.8799873 L1.32281249,58.8799873",
    id: "Path",
    stroke: "#BABABA",
    strokeWidth: 2.23890367,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 10.6459871961146
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8803465,1.11896048 L30.3253691,1.11896048 L29.8871037,1.56180819 C29.4320908,17.0617393 17.0573065,29.5663905 1.55971089,30.1864821 L1.12025887,30.6304938 L1.12025887,58.8809946",
    id: "Path",
    stroke: "#505050",
    strokeWidth: 2.23890367,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCornerScalloped);
export default __webpack_public_path__ + "static/media/icon-corner-scalloped.86b72ecdb2fff154eaef419f5ca2d658.svg";
export { ForwardRef as ReactComponent };